import { liveLanguages } from './languages.js';

export const footerGroups = [
  { title: 'Learn', links: liveLanguages.map(language => {
    const guideSlug = { gu: 'gujarati', hi: 'hindi', pa: 'punjabi' }[language.code];
    return { label: `Learn ${language.name}`, href: guideSlug ? `/learn/${guideSlug}` : `/blog/language/${language.code}` };
  }) },
  { title: 'Company', links: [{ label: 'About', href: '/about' }, { label: 'Blog', href: '/blog' }, { label: 'Careers', href: '/careers' }, { label: 'Support', href: '/support' }, { label: 'hello@bhol.app', href: 'mailto:hello@bhol.app' }] },
  { title: 'Legal', links: [{ label: 'Privacy Policy', href: '/privacy' }, { label: 'Terms of Service', href: '/terms' }] },
];
export const footerSocials = [
  { label: 'Instagram', href: 'https://www.instagram.com/learnbholapp/' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@learnbhol' },
  { label: 'X (Twitter)', href: 'https://x.com/bholbholbhol' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/bhol-app' },
];
export const footerStyles = {
  root: { background: '#1a1a1a', color: '#fff', padding: '40px 24px 28px', marginTop: 48 },
  intro: { maxWidth: 1100, margin: '0 auto 32px', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 24 },
  brand: { margin: '0 0 12px', fontSize: 28, fontWeight: 800 },
  socials: { display: 'flex', flexWrap: 'wrap', gap: 16 },
  social: { color: '#ddd', fontSize: 14, textDecoration: 'none', padding: '8px 0' },
  download: { textAlign: 'left' },
  downloadTitle: { margin: '0 0 12px', fontSize: 22, fontWeight: 750 },
  grid: { maxWidth: 1100, margin: '0 auto 32px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 28 },
  learnLinks: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', columnGap: 20 },
  links: {},
  heading: { margin: '0 0 16px', fontSize: 14, color: '#bbb', textTransform: 'uppercase', letterSpacing: '0.08em' },
  link: { display: 'block', color: '#ddd', fontSize: 15, textDecoration: 'none', padding: '7px 0' },
  bottom: { maxWidth: 1100, margin: '0 auto', paddingTop: 24, borderTop: '1px solid #444', color: '#bbb', fontSize: 13, textAlign: 'center' },
};
